module.exports = __webpack_public_path__ + "static/media/python-django-logo.32b5775c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/python-django-logo.jpg
// module id = 159
// module chunks = 0